"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var bind_1 = require("../bind");
var StarRatingSelector = /** @class */ (function (_super) {
    tslib_1.__extends(StarRatingSelector, _super);
    function StarRatingSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StarRatingSelector.prototype.handleClick = function (evt) {
        evt.preventDefault();
        this.props.onSelect(+evt.target.dataset.idx);
    };
    StarRatingSelector.prototype.renderStar = function (idx) {
        var classes = classNames('star-rating__selectable-star', { 'star-rating__selectable-star--selected': (idx <= this.props.rating) });
        return (React.createElement("button", { className: classes, onClick: this.handleClick, "data-idx": idx, key: idx }));
    };
    StarRatingSelector.prototype.render = function () {
        var classes = classNames('star-rating', 'star-rating--selector', 'star-rating--large');
        return (React.createElement("div", { className: classes }, [1, 2, 3, 4, 5].map(this.renderStar)));
    };
    tslib_1.__decorate([
        bind_1.default
    ], StarRatingSelector.prototype, "handleClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], StarRatingSelector.prototype, "renderStar", null);
    return StarRatingSelector;
}(React.Component));
exports.default = StarRatingSelector;
//# sourceMappingURL=star_rating_selector.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/star_rating_selector.js
// module id = VAob
// module chunks = 20 21